export default __webpack_public_path__ + "static/d2-0472d029e1c90ddbee69cb8f36dbf237.jpeg";